export default (function (_ref) {
  var colors = _ref.colors;
  return {
    base: {
      display: 'block',
      position: 'absolute',
      top: '-18px',
      left: 0,
      zIndex: 1,
      fontSize: '11px',
      color: colors.monotone3,
      textAlign: 'left',
      pointerEvents: 'none',
      transition: 'top 0.2s, font-size 0.2s',
      fontWeight: 300,
      marginBottom: '10px',
      paddingRight: '35px'
    },
    floating: {
      fontSize: '16px',
      top: '15px',
      left: '15px',
      '& $optional': {
        fontSize: '16px'
      }
    },
    positioned: {
      top: '7px',
      fontSize: '11px',
      '& $optional': {
        fontSize: '11px'
      }
    },
    textOverflow: {
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    error: {
      color: colors.error,
      fontWeight: 400
    },
    optional: {
      fontWeight: 300,
      fontSize: '11px',
      transition: 'font-size 0.2s'
    }
  };
});